// extracted by mini-css-extract-plugin
module.exports = {"mclLayout":"MclLayout_mclLayout__6esA8","header":"MclLayout_header__QnDCu","main":"MclLayout_main__ZeRQd","footer":"MclLayout_footer__q5NiW"};